import React from "react";
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"
import ReactHtmlParser from "react-html-parser";
import _ from "lodash";


const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    // border: 1px solid green;
    display: flex;
    padding: 8px;
    border-radius: 4px;
    background-color: ${({theme}) => theme?.backgroundColor?.default || "white"};
    @media (min-width: 600px){
        flex-direction: ${({isRow}) => isRow ? 'row' : 'column'};
        align-items: ${({isRow}) => isRow ? 'center' : 'flex-start'};
    }
    .small-image{
        max-width: 48px;
        img {
            width: 100%;
        }
    }
    .image-wrapper{
        flex-shrink: 0;
        width: 30%;
        max-width: 80px;
        img{
            width: 100%;
        }
        // max-width: 120px;
    }
    .text-wrapper{
        padding-inline: 8px;
    }
    .blue-text{
        color: ${({theme}) => theme?.colors?.blueDark || "#2F73D2"};
    }
    .pad-left{
        padding-left: 8px;
    }
    .pad-block{
        padding-block: 12px;
    }
`;


const InfoCard = ({title="", titleKey="", content="", imageSrc="", imageAlt="", isRow=false, onClick=()=>{}, isSmall = false, data={}}) => {
    return(
        <Container role="button" onClick={onClick} isRow={isRow}>
            {
                imageSrc && <div className={`"image-wrapper" ${isSmall ? "small-image pad-left pad-block": ""}`}><img src={imageSrc} alt={imageAlt} /></div>
            }
            <div className="text-wrapper">
                <Title type={isSmall ? "h4" : "h3"}>{titleKey ? _.get(data, titleKey, "") : title}</Title>
                {
                    content?.main ? <Text className="blue-text pad-block">{content?.main || ""}</Text> : <Text type="small">{ReactHtmlParser(content)}</Text>
                }
                {
                    content?.helper ? <Text type="small" className="pad-left">{content?.helper || ""}</Text> : null
                }
            </div>
        </Container>
    )
}

export default InfoCard;